var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowBackOutlinedBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 12,
    viewBox: "0 0 14 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.25 6.00068C13.25 6.19959 13.171 6.39035 13.0303 6.53101C12.8897 6.67166 12.6989 6.75068 12.5 6.75068H3.31248L6.53248 9.97005C6.67338 10.1109 6.75253 10.302 6.75253 10.5013C6.75253 10.7006 6.67338 10.8917 6.53248 11.0326C6.39158 11.1734 6.20049 11.2526 6.00123 11.2526C5.80197 11.2526 5.61088 11.1734 5.46998 11.0326L0.969981 6.53255C0.900061 6.46287 0.844583 6.38008 0.806729 6.28891C0.768875 6.19775 0.74939 6.10001 0.74939 6.0013C0.74939 5.90259 0.768875 5.80485 0.806729 5.71369C0.844583 5.62252 0.900061 5.53973 0.969981 5.47005L5.46998 0.970051C5.53975 0.900286 5.62257 0.844946 5.71372 0.807189C5.80487 0.769433 5.90257 0.75 6.00123 0.75C6.09989 0.75 6.19759 0.769433 6.28874 0.807189C6.37989 0.844946 6.46272 0.900286 6.53248 0.970051C6.60225 1.03982 6.65759 1.12264 6.69534 1.21379C6.7331 1.30494 6.75253 1.40264 6.75253 1.5013C6.75253 1.59996 6.7331 1.69766 6.69534 1.78881C6.65759 1.87996 6.60225 1.96279 6.53248 2.03255L3.31248 5.25068H12.5C12.6989 5.25068 12.8897 5.32969 13.0303 5.47035C13.171 5.611 13.25 5.80176 13.25 6.00068Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowBackOutlinedBlack);
export default __webpack_public_path__ + "static/media/arrow_back_outlined_black.b82d331bec98ddb5d1ef102bce4e9ae5.svg";
export { ForwardRef as ReactComponent };